import { type ComboboxProps } from '../combobox.tsx'
import { timezones } from '~/utils/timezones.ts'
import { utcToZonedTime } from 'date-fns-tz'
import { useEffect, useState } from 'react'
import { timeAbrev } from '~/utils/strings.ts'
import { ComboboxField, type ListOfErrors } from '../forms.tsx'
import { useHints } from '~/utils/client-hints.tsx'

export function TimeZonesSelect({
  labelProps,
  inputProps,
  errors,
  className,
}: {
  labelProps: React.LabelHTMLAttributes<HTMLLabelElement>
  inputProps: React.InputHTMLAttributes<HTMLInputElement> &
    Omit<ComboboxProps, 'options'>
  errors?: ListOfErrors
  className?: string
}) {
  const [currentTime, setCurrentTime] = useState(new Date())

  const timeZonesOptions = timezones.map(tz => ({
    value: tz,
    labelTrigger: `${tz} - ${timeAbrev(utcToZonedTime(currentTime, tz))}`,
    label: (
      <div key={'tz'} className="flex justify-between gap-1">
        <div>{tz}</div>
        <div>{timeAbrev(utcToZonedTime(currentTime, tz))}</div>
      </div>
    ),
  }))

  useEffect(() => {
    const interval = setInterval(() => {
      const currentDate = new Date()
      const currentMinute = currentDate.getMinutes()
      const previousMinute = currentTime.getMinutes()

      if (currentMinute !== previousMinute) {
        setCurrentTime(currentDate)
      }
    }, 1000)

    return () => clearInterval(interval) // Clear the interval in the componentWillUnmount lifecycle method
  }, [])

  return (
    <ComboboxField
      labelProps={labelProps}
      className={className}
      inputProps={{
        options: timeZonesOptions,
        defaultValue: useHints().timeZone,
        ...inputProps,
      }}
      errors={errors}
    />
  )
}
